import Header from "../../components/Header";
import * as S from "./style";

const Car = () => (
  <>
    <Header />
  </>
);

export default Car;
